import { Guarded } from ":setup/qrouter";
import { Route } from "@solidjs/router";
import routes from "./routes";
import { ConfirmAccount, Accepted, Certificate } from ":src/modules/attendance";

export default function Confirm() {
	const baseRoute = routes.BASE;
	return (
		<Guarded
			setup={{
				baseRoute,
			}}
			components={{
				pageNotFound: () => (
					<div>this is Attendance page error, this page doesn't exist</div>
				),
				// layout(props) {
				//   return <>{props.children}</>;
				// },
			}}
		>
			<Route path={routes.confirm_account} component={ConfirmAccount} />
			<Route path={routes.accepted} component={Accepted} />
			<Route path={routes.certificate} component={Certificate} />
		</Guarded>
	);
}
